import React, { Component, Fragment, useState } from 'react'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { Waypoint } from 'react-waypoint'
import classNames from 'classnames'
import FeaturedCategoriesCard from './FeaturedCategoriesCard'
import Carousel from '../Carousel/Carousel'
import './FeaturedCategories.scss'

const FeaturedCategoriesCarouselLayout = props => {
  const [titleViewable, setTitleViewable] = useState(false)

  //   const next = () => reactSwipe.next()

  //   const prev = () => reactSwipe.prev()

  const categories = R.pathOr([], ['categories'], props)
  ////Convert all the categories into category cards
  const allCards = categories
    .filter(cat => cat.isFeatured)
    .map((i, index) => (
      <FeaturedCategoriesCard
        key={index}
        cat={i}
        alt="category"
        link={`/category/${i.urlComponent || i.id}`}
      />
    ))
  const desktop_perPage = 8,
    tablet_perPage = 3

  const desktopSlides = R.splitEvery(desktop_perPage, allCards)
  const tabletSlides = R.splitEvery(tablet_perPage, allCards)
  ////The Ramda function R.splitEvery will put the larger arrray second and for the carousel we want it first

  ////If this is not the desired result use this line of code below
  //const allSlides = R.splitEvery(allCards.length/2, allCards)

  const allDeskSlides = desktopSlides.map((slide, index) => {
    return (
      <div key={index}>
        <div className="item container-fluid">
          <div className="row">{slide}</div>
        </div>
      </div>
    )
  })

  const allTabletSlides = tabletSlides.map((slide, index) => {
    return (
      <div key={index}>
        <div className="item container-fluid">
          <div className="row">{slide}</div>
        </div>
      </div>
    )
  })

  const mobileSlides = allCards.map((slide, index) => {
    return <div key={index}>{slide}</div>
  })

  return (
    <Fragment>
      <div className="container-fluid featured-categories">
        <div className="row" id="featured-cat-title-row">
          <Waypoint onEnter={() => setTitleViewable(true)} bottomOffset="20%">
            <div
              className={classNames('col-12 col-lg-4 col-sm-offset-1', {
                'featured-cat-title-animate': titleViewable,
                'animate-hidden': !titleViewable,
              })}
              id="featured-cat-title"
            >
              Featured Categories
            </div>
          </Waypoint>
        </div>
        <div
          className={classNames('desktop-carousel', {
            'featured-cat-carousel-animate': titleViewable,
            'animate-hidden': !titleViewable,
          })}
        >
          <Carousel
            slides={allDeskSlides}
            key={allDeskSlides.length}
            carouselControls
            carouselControlsType="triangle"
            carouselIndicators={false}
            swipeOptions={{ startSlide: 0, continuous: false, speed: 400 }}
          />
        </div>

        <div className="tablet-carousel">
          <Carousel
            slides={allTabletSlides}
            key={allTabletSlides.length}
            carouselControls
            carouselControlsType="triangle"
            carouselIndicators={false}
            swipeOptions={{ startSlide: 0, continuous: false, speed: 400 }}
          />
        </div>

        <span className="mobile-carousel">
          <Carousel
            slides={mobileSlides}
            key={mobileSlides.length}
            carouselControls
            carouselIndicators={false}
            swipeOptions={{ startSlide: 0, continuous: false, speed: 300 }}
          />
        </span>
      </div>
    </Fragment>
  )
}
const mapStateToProps = state => {
  return {
    categories: state.shopping.categories,
  }
}
export default connect(mapStateToProps)(FeaturedCategoriesCarouselLayout)
